// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details__wrapper {
  display: flex;
  background: #eeeeee;
}

.details__container {
  display: block;
  margin: 1rem;
  font-size: var(--subheader);
}

.details__title {
  font-size: var(--subheader);
  font-weight: 500;
  margin: 0;
}

.restricted-modal-container {
  display: flex;
  font-size: var(--caption);
  font-weight: normal;
  text-align: initial;
}

.restricted-modal-list {
  list-style-type: circle;
  padding-inline-start: 1.5rem;
  margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/CodeMapping/component/SearchCodeMapping/MappedCodesDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;AACrB","sourcesContent":[".details__wrapper {\n  display: flex;\n  background: #eeeeee;\n}\n\n.details__container {\n  display: block;\n  margin: 1rem;\n  font-size: var(--subheader);\n}\n\n.details__title {\n  font-size: var(--subheader);\n  font-weight: 500;\n  margin: 0;\n}\n\n.restricted-modal-container {\n  display: flex;\n  font-size: var(--caption);\n  font-weight: normal;\n  text-align: initial;\n}\n\n.restricted-modal-list {\n  list-style-type: circle;\n  padding-inline-start: 1.5rem;\n  margin-bottom: 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
